import {
  Box,
  Typography,
  Divider,
  Paper,
  Stack,
  PaperProps,
} from "@mui/material";
import { ReactNode } from "react";
import Error from "../UI/Error";
import Message from "../UI/Message";

type Props = {
  title: string;
  successText?: string;
  error?: any;
  success?: boolean;
  children: ReactNode;
  formId?: string;
  onSubmit?: (e: React.FormEvent<HTMLFormElement>) => void;
  noValidate?: boolean;
  autoComplete?: string;
};

const FormCardWrapper: React.FC<Props> = ({
  title,
  successText,
  success,
  error,
  children,
  formId,
  onSubmit,
  noValidate = true,
  autoComplete = "off",
}) => {
  return (
    <Box mx="auto" py={4}>
      <Paper
        variant="outlined"
        sx={{
          p: 4,
          backgroundColor: (theme) => theme.palette.background.default,
        }}
      >
        <Typography variant="h4" gutterBottom>
          {title}
        </Typography>

        <Divider sx={{ mb: 3 }} />

        {success && successText && (
          <Message type="success" text={successText} />
        )}
        <Error error={error} />

        <Box
          component="form"
          id={formId}
          onSubmit={onSubmit}
          noValidate={noValidate}
          autoComplete={autoComplete}
          sx={{ width: "100%", mt: 3 }}
        >
          <Stack gap={3}>{children}</Stack>
        </Box>
      </Paper>
    </Box>
  );
};

export default FormCardWrapper;
